import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  profileImage: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  avatar: {
    width: "15%",
  },
  infoContainer: {
    width: "85%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      marginTop: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  bioBox: {
    [theme.breakpoints.down("sm")]: {
      overflow: "hidden",
    },
    [theme.breakpoints.down("xs")]: {
      maxHeight: theme.spacing(3),
      marginTop: 0,
    },
  },
}))

export default styles
